<div class="kt-portlet">
    <div class="kt-portlet__head  d-flex align-items-center justify-content-between">
        <div class="kt-portlet__head-label">
            <h3 class="kt-portlet__head-title">
                Gönüllü güncelle - Rol atama - ({{user.displayName}})
            </h3>
        </div>
        <button type="button" routerLink="/volunteer-list" class="btn btn-secondary mr-3">Geri Dön</button>
    </div>
    <div class="container" style="width: 90%">
        <form class="kt-form kt-form--label-left" [formGroup]="upgradeUserForm" (ngSubmit)="save()" autocomplete="off">
            <div class="kt-portlet__body">
                <div class="form-group">
                    <label for="roleId" class="col-form-label">Roller</label>
                    <ng-select name="roleId" id="roleId" labelForId="roleId"
                        bindValue="id" style="width: 100%; padding: 5px; float: left;clear: both;" placeholder="Roller" [items]="roles"
                        bindLabel="roleName" formControlName="roleId">
                    </ng-select>
                </div>
            </div>
            <div class="kt-portlet__foot">
                <div class="kt-form__actions">
                    <div class="row">
                        <div class="col-12 d-flex justify-content-end">
                            <button type="button" class="btn btn-success" (click)="save()">Kaydet</button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>